import React from "react";
import EnrolmentAdjustment from "../EnrolmentAdjustment";

const EnrolmentAdjustmentComponent = () => {
  return <EnrolmentAdjustment status="class-allocated" title="class-allocated" />;
};

export default EnrolmentAdjustmentComponent;
